import LocalStorage from "@/lib/LocalStorage";

export default {
    namespaced: true,
    state: {
        postpone_duration: 1 * 60 * 60 * 1000, // 1 hour
        is_out_of_date: false,
        postponed_until: null,
        server_version: null,
    },
    getters: {
        shouldDisplayUpdater: (state) =>
            !!state.is_out_of_date && state.postponed_until < Date.now(),

        readableServerVersion: (state) =>
            state.server_version
                ? state.server_version.substring(0, 8)
                : "unknown",
        readableMyVersion: (state, getters) => {
            const version = getters.myVersion;
            return version ? version.substring(0, 8) : "unknown";
        },

        myVersion: () => {
            let version = null;
            try {
                const updater = LocalStorage.GetItem("updater");
                if (updater) {
                    const parsed = JSON.parse(updater);
                    if (parsed && parsed.version) {
                        version = parsed.version;
                    }
                }
            } catch (e) {
                console.warn(
                    "Error parsing updater version from localStorage",
                    e
                );
                // ignore parse errors
            }
            if (version) {
                return version;
            }

            return process.env.VUE_APP_VERSION
                ? process.env.VUE_APP_VERSION
                : "unknown";
        },
    },
    mutations: {
        setServerVersion(state, server_version) {
            state.server_version = server_version;
        },
        setIsOutOfDate(state, out_of_date) {
            state.is_out_of_date = out_of_date;
        },

        postponeUpdate(state, should_pospone = true) {
            if (!should_pospone) {
                state.postponed_until = null;

                return;
            }

            state.postponed_until = new Date(
                Date.now() + state.postpone_duration
            );
        },
    },
};
